module.exports = "<div class=\"row\">\n  <div class=\"col-12-xs cont\">\n    <h1>404</h1>\n    <p>The page you are looking for was moved, removed, renamed or might never existed.</p>\n    <a [routerLink]=\"['']\" class=\"btn btn-primary-outline mt24\">Return</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/layout/no-content/no-content.component.html
// module id = ../../../../../src/app/layout/no-content/no-content.component.html
// module chunks = main